import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TapoMatter() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Matter Technology | TP-Link | SeguraTech</title>
        <meta
          name="description"
          content="Learn how TP-Link’s Matter-compatible devices deliver seamless integration across Apple, Google, and Amazon smart home ecosystems."
        />
        <meta property="og:title" content="Matter Technology | TP-Link | SeguraTech" />
        <meta
          property="og:description"
          content="Matter unifies smart home connectivity — TP-Link Tapo devices ensure compatibility and reliability across major platforms."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seguratech.co.uk/tplink/matter" />
        <meta property="og:image" content="/tplink-logo.png" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-4xl mx-auto px-4 py-24 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-6">
          Matter Technology
        </h1>
        <p className="text-lg text-white/80 mb-10">
          TP-Link’s Matter-compatible devices bring true interoperability to your smart home. 
          Matter ensures your lighting, plugs, hubs, and sensors work together — no matter the brand.
        </p>
      </section>

      {/* Key Features */}
      <section className="max-w-6xl mx-auto px-4 pb-24 grid md:grid-cols-2 gap-10 text-center">
        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">Universal Compatibility</h3>
          <p className="text-white/80">
            Matter-certified devices from TP-Link work seamlessly with Apple Home, Google Home, and Alexa ecosystems.
          </p>
        </div>

        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">Future-Proof Connectivity</h3>
          <p className="text-white/80">
            Built on a secure and open-source protocol, Matter ensures long-term compatibility and simplified setup for all connected devices.
          </p>
        </div>
      </section>

      {/* Back Link */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
